import { render, staticRenderFns } from "./toggle-switch.html?vue&type=template&id=a841177c&scoped=true&"
import script from "./toggle-switch.js?vue&type=script&lang=js&"
export * from "./toggle-switch.js?vue&type=script&lang=js&"
import style0 from "./toggle-switch.scss?vue&type=style&index=0&id=a841177c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a841177c",
  null
  
)

export default component.exports